/**
 * Utilidades para validar el estatus de las hojas quirúrgicas
 */

/**
 * Valida el estatus de las coberturas de hoja quirúrgica
 * Ahora usa el campo 'estatus' del detalle de coberturas en lugar de 'estatusValidacion'
 * @param {Array} coberturas - Array de objetos con campo 'estatus' (del endpoint consultadetallecobertura)
 * @returns {Object} - Objeto con el resultado de la validación
 */
export const validarEstatusHojaQuirurgica = (coberturas = []) => {
  if (!Array.isArray(coberturas) || coberturas.length === 0) {
    return {
      debeBloquear: false,
      tipoEstatus: null,
      mensaje: null,
    };
  }

  // Contar cuántas coberturas tienen cada estatus ("Pendiente" y "En proceso" = pendiente)
  const esPendiente = (estatus) => estatus === "Pendiente" || estatus === "En proceso";
  const tienePendiente = coberturas.some((c) => esPendiente(c.estatus));
  const tieneRechazado = coberturas.some((c) => c.estatus === "Rechazado");
  const tieneCompletado = coberturas.some((c) => c.estatus === "Completado");

  const todasRechazadas = coberturas.every((c) => c.estatus === "Rechazado");
  const todasCompletadas = coberturas.every((c) => c.estatus === "Completado");

  // 1. Si hay alguna con estatus "Pendiente" o "En proceso"
  if (tienePendiente) {
    return {
      debeBloquear: true,
      tipoEstatus: "PENDIENTE",
      mensaje: "Ingreso restringido por validación médica.\n\nLas cirugías registradas en la validación Hojas Quirúrgicas se encuentran en proceso de validación. El cierre de la cuenta clínica permanecerá restringido hasta recibir la respuesta del área médica.",
    };
  }

  // 2. Si todas están "Rechazado"
  if (todasRechazadas) {
    return {
      debeBloquear: true,
      tipoEstatus: "RECHAZADO",
      mensaje: "La solicitud de validación de cirugías adicionales no fue aprobada. Por este motivo, el proceso de alta no puede gestionarse a través de WebSalud.\n\nPara concluir la de alta médica, comuníquese con nuestro Centro de Atención al Cliente.",
    };
  }

  // 3. Si hay mezcla de "Rechazado" y "Completado" (aprobación parcial)
  if (tieneRechazado && tieneCompletado) {
    return {
      debeBloquear: true,
      tipoEstatus: "APROBACION_PARCIAL",
      mensaje: "Las cirugías adicionales fueron aprobadas parcialmente por el área médica. Debido a coberturas no autorizadas, el proceso de alta no puede continuar en WebSalud. Para concluir la de alta, contacte a nuestro Centro de Atención al Cliente.",
    };
  }

  // 4. Si todas están "Completado"
  if (todasCompletadas) {
    return {
      debeBloquear: false,
      tipoEstatus: "COMPLETADO",
      mensaje: "Validación completada\n\nEl área médica ha aprobado la totalidad de las cirugías adicionales solicitadas.\n\nLa pantalla de Egresos ha sido habilitada y ya puede continuar con el registro de los gastos clínicos y las cirugías autorizadas.",
    };
  }

  // Caso por defecto (no debería llegar aquí normalmente)
  return {
    debeBloquear: false,
    tipoEstatus: "DESCONOCIDO",
    mensaje: null,
  };
};

/**
 * Extrae el número de ingreso del formato "2026-9661351"
 * @param {string} numeroIngresoCompleto - Número de ingreso completo
 * @returns {string|null} - El segundo elemento (secuencial) o null si no es válido
 */
export const extraerNumeroIngreso = (numeroIngresoCompleto) => {
  if (!numeroIngresoCompleto || typeof numeroIngresoCompleto !== "string") {
    return null;
  }

  const partes = numeroIngresoCompleto.split("-");
  if (partes.length >= 2) {
    return partes[1];
  }

  return null;
};
